import React from "react";
import { VisionMission, WhyChooseUs } from "../components/AboutUs";
import Navbar from "../components/Navbar/Navbar";

const Vision = () => (
  <main>
    <Navbar />
    {/* <AboutHero /> */}
    <VisionMission />
    <WhyChooseUs />
  </main>
);

export default Vision;
